export function getInitials(name) {
  if (!name) return '';

  const words = name.trim().split(/\s+/); // Split by spaces
  const initials = words.map((word) => word[0].toUpperCase()).join('');

  return initials;
}
